<style lang="less" scoped>
    .login-container {
        width: 100%;
        height: 100%;
        background: linear-gradient(157deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
        display: flex;
        justify-content: center;
        align-items: center;
        .login-form-div {
            width: 1127px;
            height: 701px;
            border-radius: 29px;
            background-image: url("../../assets/login/login-bg.png");
            background-size: 100% 100%;
            position: relative;
            .ab-version-div {
                position: absolute;
                top: 36px;
                right: 36px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(143, 155, 179, 1);
                line-height: 20px;
            }
            .form-child-div {
                margin-left: 64px;
                margin-top: 100px;
                width: 280px;
            }
            .pro-title-div {
                font-size: 28px;
                font-weight: 600;
                color: rgba(52, 52, 52, 1);
                line-height: 40px;
                height: 40px;
            }
            .welcome-title-div {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                line-height: 20px;
                height: 20px;
                margin-top: 16px;
                margin-bottom: 72px;
            }
            .form-line-title {
                font-size: 14px;
                font-weight: 400;
                color: rgba(143, 155, 179, 1);
                line-height: 20px;
                margin-top: 12px;
            }
            .form-line-input {
                .form-input {
                    border: 0;
                    outline: 0;
                    border-bottom: 1px solid #8F9BB3;
                    width: 100%;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                }
            }
            .pwd-title {
                margin-top: 24px;
            }
            .submit-btn-div {
                display: flex;
                flex-direction: row-reverse;
                margin-top: 32px;
                .submit-btn {
                    width: 140px;
                    outline: 0;
                    height: 45px;
                    background: rgba(187, 135, 243, 1);
                    border-radius: 24px;
                    border: 0;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 45px;
                    cursor: pointer;
                }
            }
        }
        .fixed-auth-div {
            position: fixed;
            bottom: 16px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            .auth-up-div {
                margin-bottom: 10px;
            }
            .ba {
                margin-left: 32px;
            }
        }
    }
</style>

<template>
    <div class="login-container">
        <div class="login-form-div">
            <!-- 登录表单 -->
            <div class="form-child-div">
                <div class="pro-title-div">桩到家充电运营平台</div>
                <div class="welcome-title-div">欢迎来到桩到家充电运营平台</div>
                <div class="form-line-title">请输入手机号</div>
                <div class="form-line-input">
                    <input type="text" v-model="formInfo.userPhone" class="form-input user-name-input">
                </div>
                <div class="form-line-title pwd-title">请输入密码</div>
                <div class="form-line-input">
                    <input type="password" v-model="formInfo.userPassword" class="form-input user-name-input">
                </div>
                <div class="submit-btn-div">
                    <button class="submit-btn" @click="submitForm">登 录</button>
                </div>
            </div>
            <!-- version -->
            <div class="ab-version-div">版本:1.1.0</div>
        </div>
        <div class="fixed-auth-div">
            <div class="auth-up-div flex">
                <div class="text-center flex-1">挚达科技</div>
                <div class="text-center flex-1">服务协议</div>
                <div class="text-center flex-1">客服:400-6596-580</div>
            </div>
            <div class="auth-bottom-div">
                <span class="copyright">Copyright © 2012-2020 上海挚达科技发展有限公司版权所有</span>
                <span class="ba">沪ICP备14017068号-2</span>
            </div>
        </div>
    </div>
</template>

<script>
    import enAes from "../../common/enAes";
    export default {
        data() {
            return {
                formInfo: {},
            }
        },
        methods: {
            init() {
                localStorage.removeItem('userPhone')
            },
            // 登录
            submitForm(formName) {
                let _ = this;
                // 判断用户名是否输入
                if (_.$U.isEmpty(_.formInfo.userPhone)) {
                    _.$U.error('请输入手机号');
                    return;
                }
                // 判断用户名是否输入
                if (_.$U.isEmpty(_.formInfo.userPassword)) {
                    _.$U.error('请输入密码');
                    return;
                }
                _.$U.showLoading(_);
                _.formInfo.corpNo = _.$C.corpNo;
                _.formInfo.loginType = '01';
                _.formInfo.dataCheck = 'Y';
                localStorage.setItem('userPhone',_.formInfo.userPhone)
                const loginForm = {
                    ..._.formInfo,
                    userPassword: enAes.Encrypt(_.formInfo.userPassword),
                };
                _.$H.post(_, _.$A.login, loginForm).then(res => {
                    let token = res.headers.authorization;
                    _.$store.commit('setToken', token);
                    _.$store.commit('setCorpNo', _.$C.corpNo);
                    // 获取当前用户信息
                    _.$H.get(_, _.$A.user.currentUserInfo, {}).then(userRes => {
                        const roleId = userRes.data.data.roleId;
                        _.$store.commit('setUserInfo', userRes.data.data);
                        
                        // 获取当前用户的菜单列表
                        _.$H.post(_, _.$A.role.listmenu, {roleId:roleId}).then(userMenus => {
                            let menuRes = userMenus.data.data;
                            let menuList = [];
                            let router = '';
                            menuRes.forEach(item => {
                              if(item.menuType === '01'){
                                return router = item.menuNameEn
                              }
                              if(item.menuLevel === 2){
                                return router = item.menuNameEn
                              }
                             })

                            menuRes.forEach(menu => {
                                menuList.push(menu.menuNameEn);
                            });

                            _.$store.commit('setCurUserMenuList',menuList);
                            _.$U.hideLoading(_);
                            _.$router.push({
                                name: router,
                            });
                        });
                    });
                })
                //     }
                // });
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
